import classNames from 'classnames';
import { forwardRef, type HTMLAttributes, memo } from 'react';

export type TableRowProps = {
  className?: string;
} & HTMLAttributes<HTMLDivElement>;

export const TableRow = memo(
  forwardRef<HTMLDivElement, TableRowProps>(({ className, ...props }, ref) => (
    <div
      tabIndex={0}
      className={classNames('tableRow flex items-center text-14 text-grey-10', className)}
      ref={ref}
      {...props}
    />
  )),
);

TableRow.displayName = 'TableRow';
